import React, { FC, useState } from 'react';
import useTranslation from '@hooks/useTranslation';
import TitleTemplate, { TitleTagTypes } from '@ui/SectionTitle/Title';
import ContentWrapper from '../../ui/Content/Content';
import { Customer, Customers, ShowMoreButton, Wrapper } from './Customers.elements';
import useScrollToSection from "@hooks/useScrollToSection";

const DEFAULT_COUNT_OF_VISIBLE_CUSTOMERS = 21;

interface CustomersProps {}

const CustomersTemplate: FC<CustomersProps> = () => {
    const { t } = useTranslation();

    const [countOfVisibleCustomers, setCountOfVisibleCustomer] = useState(21);

    useScrollToSection('reference', 'klienti');

    const customers = [
        'Asseco Solutions, a. s.',
        'Adler Czech, a. s.',
        'BOSCH DIESEL, s. r. o.',
        'Česká národní banka',
        'Česká spořitelna, a. s.',
        'ČEZ, a. s.',
        'ČSOB pojišťovna, a. s.',
        'AFSI Europe s. r. o.',
        'AGC Automotive Czech a. s.',
        'Agentura pro podporu podnikání a investic CzechInvest',
        'ArcelorMittal FCE CZ s. r. o.',
        'AUMA - Servopohony spol. s r. o.',
        'Auto-Kabel Krupka, s. r. o.',
        'AŽD Praha s. r. o.',
        'B. Braun Medical s. r. o.',
        'BAEST, a. s.',
        'BENTELER ČR s. r. o.',
        'BRISK Tábor, a. s.',
        'Bystronic Czech Republic s.r.o.',
        'Callida, s. r. o.',
        'ComAp a.s.',
        'Crede Experto Praha spol. s r. o.',
        'ČEPRO, a. s.',
        'ČEPS, a. s.',
        'Česká pojišťovna, a. s.',
        'Česká republika - Ministerstvo vnitra',
        'ČESKÁ TELEVIZE',
        'Česká zemědělská univerzita v Praze',
        'České aerolinie a. s.',
        'Českomoravská stavební spořitelna, a. s.',
        'Českomoravská záruční a rozvojová banka, a. s.',
        'Československá obchodní banka, a.s.',
        'Český Aeroholding, a. s.',
        'Český plynárenský svaz',
        'Český rozhlas',
        'ČEZ ICT Services, a. s.',
        'ČEZ Korporátní služby, s. r. o.',
        'ČSOB Leasing, a. s.',
        'Denso Manufacturing Czech s. r. o.',
        'Devro, s. r. o.',
        'DONALDSON CZECH REPUBLIC s. r. o.',
        'Donaldson Industrial CR - koncern s.r.o.',
        'Doosan Bobcat Manufacturing s. r. o.',
        'Driessen Aerospace CZ s. r. o.',
        'DURA Automotive CZ, k. s.',
        'Eberspächer spol. s r. o.',
        'EGE, spol. s r. o.',
        'Ernst & Young, s. r. o.',
        'Geis CZ s. r. o.',
        'Husqvarna Česko s. r. o.',
        'Kaufland Česká republika v. o. s.',
        'Kooperativa pojišťovna, a.s.',
        'Metrostav a. s.',
        'OMV Česká republika, s. r. o.',
        'Energetické opravny, a. s.',
        'Engel strojírenská spol. s r. o.',
        'Exportní garanční a pojišťovací společnost a. s.',
        'Faurecia Emissions Control Technologies Mladá Boleslav, s. r. o.',
        'Fibertex Nonwovens, a. s.',
        'FTE automotive Czechia s. r. o.',
        'GEFCO Česká republika s. r. o.',
        'GRAMMER CZ, s. r. o.',
        'GRUPO ANTOLIN TURNOV s. r. o.',
        'HDS Retail Czech Republic, a. s.',
        'Hlavní město Praha',
        'HM Studio a. s.',
        'INISOFT s. r. o.',
        'InterScreen, s. r. o.',
        'JABLOTRON ALARMS a. s.',
        'Johnson Controls Autobaterie spol. s r. o.',
        'Johnson Controls Automobilové součástky k. s.',
        'Kalora a. s.',
        'KLEPIERRE MANAGEMENT ČESKÁ REPUBLIKA s. r. o.',
        'Komerční banka, a. s.',
        'Krajská správa a údržba silnic Vysočiny, příspěvková organizace',
        'KS - Europe, s. r. o.',
        'KS Kolbenschmidt Czech Republic, a. s.',
        'MARSH s. r. o.',
        'Mercedes-Benz Financial Services Česká republika s. r. o.',
        'Městská policie hl. m. Prahy',
        'Ministerstvo financí ČR',
        'Ministerstvo pro místní rozvoj ČR',
        'Ministerstvo školství, mládeže a tělovýchovy',
        'Ministerstvo zemědělství ČR',
        'MOSER, a. s.',
        'Nemocnice Na Homolce',
        'Oborová zdravotní pojišťovna zaměstnanců bank, pojišťoven a stavebnictví',
        'Ochranný svaz autorský pro práva k dílům hudebním, o. s.',
        'Otavské strojírny a. s.',
        'Pacific Direct s. r. o.',
        'Panasonic Liquid Crystal Display Czech, s. r. o.',
        'PEPSICO CZ, s. r. o.',
        'Pozemkový fond České republiky',
        'PPF a. s.',
        'Schenker, spol. s r. o.',
        'Siemens, s. r. o.',
        'Skanska a. s.',
        'ŠKODA AUTO a. s.',
        'Telefónica Czech Republic, a. s.',
        'Tesco Stores ČR, a. s.',
        'UPC Česká republika, s. r. o.',
        'Pražská energetika, a. s.',
        'Pražská teplárenská a. s.',
        'PWO UNITOOLS CZ a. s.',
        'Robert Bosch odbytová s. r. o.',
        'Robert Bosch spol. s r. o.',
        'RODENSTOCK ČR s. r. o.',
        'Rodinný pivovar Bernard a. s.',
        'ROHDE & SCHWARZ - Praha, s.r.o.',
        'Roche, s. r. o.',
        'Rudolf Kämpf s.r.o.',
        'RWE GasNet, s. r. o.',
        'RWE Interní služby, s. r. o.',
        'RWE Transgas, a. s.',
        'Řízení letového provozu ČR, s. p.',
        'SAFINA, a. s.',
        'SAS Autosystemtechnik s. r. o.',
        'Sellier & Bellot a. s.',
        'SENCO PŘÍBRAM spol. s r. o.',
        'Severočeské doly a. s.',
        'SMP CZ, a. s.',
        'Spojené kartáčovny a. s.',
        'Státní fond životního prostředí ČR',
        'Státní zemědělský intervenční fond',
        'STAVIMEX Praha, a. s.',
        'Svaz českých a moravských výrobních družstev',
        'ŠKO-ENERGO, s. r. o.',
        'TEDOM a. s.',
        'TESCO STORES SR, a. s.',
        'TI Group Automotive Systems s. r. o.',
        'Toyoda Gosei Czech, s. r. o.',
        'Travelex Czech Republic a. s.',
        'ÚJV Řež, a. s.',
        'UNIPETROL RPA, s. r. o.',
        'UNIPETROL SERVICES, s. r. o.',
        'VALEO AUTOKLIMATIZACE k. s.',
        'VIAMONT, a. s.',
        'Všeobecná zdravotní pojišťovna ČR',
        'Wolters Kluwer ČR, a. s.',
        'Zentiva Group, a. s.',
        'ZENTIVA, k. s.',
    ];

    return (
        <ContentWrapper id="klienti" mobileSidePadding={20}>
            <Wrapper>
                <TitleTemplate tagType={TitleTagTypes.H3} isBlack>
                    {t('about.customers.title')}
                </TitleTemplate>
                <Customers>
                    {customers.slice(0, countOfVisibleCustomers).map((customer, key) => (
                        <Customer key={key}>{customer}</Customer>
                    ))}
                </Customers>
                <ShowMoreButton
                    onClick={() =>
                        countOfVisibleCustomers === customers?.length
                            ? setCountOfVisibleCustomer(DEFAULT_COUNT_OF_VISIBLE_CUSTOMERS)
                            : setCountOfVisibleCustomer(customers.length)
                    }
                >
                    {countOfVisibleCustomers === customers?.length
                        ? t('about.customers.button.showLess')
                        : t('about.customers.button.showMore')}
                </ShowMoreButton>
            </Wrapper>
        </ContentWrapper>
    );
};
export default CustomersTemplate;
